import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const FountainOfYouth = {
  id: "73",
  name: "Fountain of Youth",
  width: 3,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Fountain_Of_Youth",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Fountain_of_Youth',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          15, 15, 15, 25, 25, 35, 35, 35, 45, 45, 55, 55, 55, 65, 65, 75, 75, 75,
          85, 85, 89, 89, 89, 95, 95, 99, 99, 99, 105, 105, 109, 109, 109, 115,
          115, 119, 119, 119, 125, 127, 129, 131, 133, 135, 137, 139, 141, 143,
          145, 147, 149, 151, 153, 155, 157, 159, 161, 163, 165, 167,
        ],
        bronzeAge: [
          20, 20, 20, 40, 40, 60, 60, 60, 75, 75, 85, 85, 85, 100, 100, 120, 120,
          120, 150, 150, 156, 156, 156, 165, 165, 171, 171, 171, 180, 180, 186,
          186, 186, 195, 195, 201, 201, 201, 210, 213, 216, 219, 222, 225, 228,
          231, 234, 237, 240, 243, 246, 249, 252, 255, 258, 261, 264, 267, 270,
          273,
        ],
        minoanEra: [
          30, 30, 30, 60, 60, 90, 90, 90, 110, 110, 130, 130, 130, 150, 150, 170,
          170, 170, 206, 206, 215, 215, 215, 228, 228, 237, 237, 237, 251, 251,
          260, 260, 260, 273, 273, 282, 282, 282, 296, 300, 304, 309, 313, 318,
          322, 327, 331, 336, 340, 345, 349, 354, 358, 363, 367, 372, 376, 381,
          385, 390,
        ],
        classicGreece: [
          40, 40, 40, 80, 80, 120, 120, 120, 140, 140, 160, 160, 160, 180, 180,
          200, 200, 200, 295, 295, 305, 305, 305, 320, 320, 330, 330, 330, 345,
          345, 355, 355, 355, 370, 370, 380, 380, 380, 395, 400, 405, 410, 415,
          420, 425, 430, 435, 440, 445, 450, 455, 460, 465, 470, 475, 480, 485,
          490, 495, 500,
        ],
        earlyRome: [
          50, 50, 50, 100, 100, 150, 150, 150, 170, 170, 200, 200, 200, 230, 230,
          275, 275, 275, 364, 364, 376, 376, 376, 394, 394, 406, 406, 406, 424,
          424, 436, 436, 436, 454, 454, 466, 466, 466, 484, 490, 496, 502, 508,
          514, 520, 526, 532, 538, 544, 550, 556, 562, 568, 574, 580, 586, 592,
          598, 604, 610,
        ],
        romanEmpire: [
          60, 60, 60, 120, 120, 180, 180, 180, 200, 200, 230, 230, 230, 270, 270,
          320, 320, 320, 403, 403, 417, 417, 417, 438, 438, 452, 452, 452, 473,
          473, 487, 487, 487, 508, 508, 522, 522, 522, 543, 550, 557, 564, 571,
          578, 585, 592, 599, 606, 613, 620, 627, 634, 641, 648, 655, 662, 669,
          676, 683, 690,
        ],
        byzantineEra: [
          70, 70, 70, 140, 140, 210, 210, 210, 250, 250, 280, 280, 280, 320, 320,
          370, 370, 370, 452, 452, 468, 468, 468, 492, 492, 508, 508, 508, 532,
          532, 548, 548, 548, 572, 572, 588, 588, 588, 612, 620, 628, 636, 644,
          652, 660, 668, 676, 684, 692, 700, 708, 716, 724, 732, 740, 748, 756,
          764, 772, 780,
        ],
        ageOfTheFranks: [
          80, 80, 80, 160, 160, 240, 240, 240, 270, 270, 310, 310, 310, 350, 350,
          420, 420, 420, 521, 521, 539, 539, 539, 566, 566, 584, 584, 584, 611,
          611, 629, 629, 629, 656, 656, 674, 674, 674, 701, 710, 719, 728, 737,
          746, 755, 764, 773, 782, 791, 800, 809, 818, 827, 836, 845, 854, 863,
          872, 881, 890,
        ],
        feudalAge: [
          90, 90, 90, 180, 180, 270, 270, 270, 310, 310, 350, 350, 350, 400, 400,
          500, 500, 500, 651, 651, 669, 669, 669, 696, 696, 714, 714, 714, 741,
          741, 759, 759, 759, 786, 786, 804, 804, 804, 831, 840, 849, 858, 867,
          876, 885, 894, 903, 912, 921, 930, 939, 948, 957, 966, 975, 984, 993,
          1002, 1011, 1020,
        ],
        iberianEra: [
          100, 100, 100, 200, 200, 300, 300, 300, 330, 330, 380, 380, 380, 450,
          450, 550, 550, 550, 690, 690, 710, 710, 710, 740, 740, 760, 760, 760,
          790, 790, 810, 810, 810, 840, 840, 860, 860, 860, 890, 900, 910, 920,
          930, 940, 950, 960, 970, 980, 990, 1000, 1010, 1020, 1030, 1040, 1050,
          1060, 1070, 1080, 1090, 1100,
        ],
        kingdomOfSicily: [
          110, 110, 110, 220, 220, 330, 330, 330, 360, 360, 415, 415, 415, 470,
          470, 620, 620, 620, 809, 809, 831, 831, 831, 864, 864, 886, 886, 886,
          919, 919, 941, 941, 941, 974, 974, 996, 996, 996, 1029, 1040, 1051,
          1062, 1073, 1084, 1095, 1106, 1117, 1128, 1139, 1150, 1161, 1172, 1183,
          1194, 1205, 1216, 1227, 1238, 1249, 1260,
        ],
        highMiddleAges: [
          120, 120, 120, 240, 240, 360, 360, 360, 420, 420, 500, 500, 500, 600,
          600, 700, 700, 700, 828, 828, 852, 852, 852, 888, 888, 912, 912, 912,
          948, 948, 972, 972, 972, 1008, 1008, 1032, 1032, 1032, 1068, 1130, 1142,
          1154, 1166, 1178, 1190, 1202, 1214, 1226, 1238, 1250, 1262, 1274, 1286,
          1298, 1310, 1322, 1334, 1346, 1358, 1370,
        ],
        earlyGothicEra: [
          122, 122, 122, 247, 247, 370, 370, 370, 435, 435, 518, 518, 518, 623,
          623, 726, 726, 726, 859, 859, 886, 886, 886, 927, 927, 954, 954, 954,
          995, 995, 1022, 1022, 1022, 1063, 1063, 1090, 1090, 1090, 1131, 1170,
          1183, 1196, 1209, 1222, 1235, 1248, 1261, 1274, 1287, 1300, 1313, 1326,
          1339, 1352, 1365, 1378, 1391, 1404, 1417, 1430,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        ],
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 5
      ]),
    ),
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level <= 2) {
            return 1.1;
          }
          if (level <= 7) {
            return 1.9;
          }
          if (level <= 12) {
            return 2.7;
          }
          if (level <= 17) {
            return 3.5;
          }
          if (level <= 22) {
            return 4.3;
          }
          if (level <= 27) {
            return 5.1;
          }
          if (level <= 32) {
            return 5.9;
          }
          if (level <= 37) {
            return 6.7;
          }
          if (level <= 38) {
            return 7.5;
          }
          if (level <= 40) {
            return 7.8;
          }
          return 0.1 * (level - 40);
        }
      ),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        0, 1.9, 1.9, 1.9, 2.3, 2.3, 2.7, 2.7, 2.7, 3.1,
        3.1, 3.3, 3.3, 3.3, 3.6, 3.6, 3.95, 3.95, 3.95, 4.35,
        4.35, 4.6, 4.6, 4.6, 5.05, 5.05, 5.3, 5.3, 5.3, 5.8,
        5.8, 6.2, 6.2, 6.2, 6.55, 6.55, 6.9, 6.9, 6.9, 7.25,
        8, 8, 8, 8, 8, 8, 8, 9, 9, 9,
        9, 9, 9, 9, 10, 10, 10, 10, 10, 10
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
};

export default FountainOfYouth;
